module.exports = __webpack_public_path__ + "img/no-personligutvikling.fec3a80c.png";